import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'
import { HttpHelperService } from '../http.service'

@Injectable({
  providedIn: 'root',
})
export class ReportsApiService {
  private http = inject(HttpClient)
  private httpHelper = inject(HttpHelperService)

  getJobsBetweenTasks(
    taskMasterIdDone: number,
    taskMasterIdIncomplete: number
  ): Observable<string[]> {
    const params = new HttpParams()
      .set('taskMasterIdDone', taskMasterIdDone)
      .set('taskMasterIdIncomplete', taskMasterIdIncomplete)

    return this.http.get<string[]>(
      environment.apiUrl + 'reports/jobs-between-tasks',
      { ...this.httpHelper.httpReadOnlyOptions, params }
    )
  }
}